import { Injectable } from '@angular/core';
import { Principal } from './principal.service';
import { AuthServerProvider } from './auth.service';
import { UserCredentials } from '../../model/user-credentials';
import { CrewEventManager } from '../event-manager.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoginService {
    constructor(
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private eventManager: CrewEventManager
    ) { }

    login(credentials: UserCredentials): Observable<any> {
        return this.authServerProvider.login(credentials).pipe(
            tap(
                () => this.principal.identity(true).subscribe(),
                () => this.logout()));
    }

    logout(): void {
        this.authServerProvider.logout().subscribe();
        this.principal.clearUserIdentity();

        this.eventManager.logoutSuccess();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/auth/login.service.ts